import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSettings = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      d="M8.824 2.498c.808-3.33 5.544-3.33 6.352 0a.869.869 0 0 0 1.297.537C19.4 1.252 22.75 4.6 20.967 7.528a.869.869 0 0 0 .536 1.296c3.33.808 3.33 5.544 0 6.352a.869.869 0 0 0-.538 1.297c1.783 2.926-1.566 6.276-4.493 4.494a.869.869 0 0 0-1.296.536c-.808 3.33-5.544 3.33-6.352 0a.869.869 0 0 0-1.297-.538C4.6 22.748 1.25 19.4 3.034 16.472a.869.869 0 0 0-.537-1.296c-3.33-.808-3.33-5.544 0-6.352a.869.869 0 0 0 .538-1.297C1.252 4.6 4.6 1.25 7.527 3.033a.867.867 0 0 0 1.297-.535Zm3.978.433c-.302-.75-1.443-.706-1.646.133a3.267 3.267 0 0 1-4.876 2.02C5.5 4.61 4.61 5.5 5.084 6.277a3.269 3.269 0 0 1-2.02 4.878c-.885.215-.885 1.473 0 1.688a3.269 3.269 0 0 1 2.02 4.877l-.055.102c-.342.75.505 1.546 1.249 1.093a3.269 3.269 0 0 1 4.878 2.02c.215.885 1.473.885 1.688 0a3.269 3.269 0 0 1 4.876-2.02l.103.055c.75.342 1.546-.505 1.093-1.249a3.27 3.27 0 0 1 2.02-4.878c.885-.215.885-1.473 0-1.688a3.27 3.27 0 0 1-2.02-4.876l.055-.102c.342-.752-.505-1.547-1.249-1.094a3.269 3.269 0 0 1-4.878-2.021l-.042-.132ZM12 7.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6Zm0 2.4a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSettings);
export default ForwardRef;
